import { Prisma } from "@prisma/client";

export const invoiceTypeArray = ["order", "event"] as const;

export type InvoiceType = (typeof invoiceTypeArray)[number];

export const isInvoiceType = (type: string): type is InvoiceType =>
  invoiceTypeArray.includes(type as InvoiceType);

export const onlineOrderDetailsInvoiceArgs = {
  include: { file: true },
} satisfies Prisma.OnlineOrderDetails$invoiceArgs;

export type OnlineOrderDetailsInvoice = Prisma.InvoiceGetPayload<typeof onlineOrderDetailsInvoiceArgs>;

export const eventInvoiceValues =
  Prisma.validator<Prisma.EventInvoiceDefaultArgs>()({
    include: { file: true },
  });

export type EventInvoice = Prisma.EventInvoiceGetPayload<
  typeof eventInvoiceValues
>;

export type GenerateProfessionalInvoicesBody = {
  from: string;
  to: string;
  invoiceDate?: string | null;
};
